import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('temporaryDrawerHeadingGroup', [
  'header',
  'heading',
  'subheading',
  'toolbar',
  'toolbarStartCol',
  'toolbarEndCol',
  'hasBackAction',
]);

const getHeadingGroupCss = css`
  display: flex;
  flex-direction: column;
  padding: 0 var(--cds-spacing-200) var(--cds-spacing-300);

  .${classes.header} {
    flex: 1 1 auto;
  }

  .${classes.toolbar} {
    display: flex;
    order: -1;
    flex: 1 0 auto;
    margin-bottom: var(--cds-spacing-50);
  }

  .${classes.toolbarStartCol} {
    flex: 1 0 auto;
  }

  .${classes.toolbarEndCol} {
    flex: 0 0 auto;
  }

  .${classes.subheading} {
    margin-top: var(--cds-spacing-50);
  }

  ${breakpoints.up('sm')} {
    padding: 0 var(--cds-spacing-400) var(--cds-spacing-400);
  }

  ${breakpoints.up('md')} {
    flex-direction: row;
    align-items: flex-start;
    padding-left: var(--cds-spacing-600);
    padding-right: var(--cds-spacing-600);

    .${classes.toolbar} {
      flex: 0 0 auto;
      order: initial;
    }

    .${classes.header} {
      margin-right: var(--cds-spacing-300);
    }

    &.${classes.hasBackAction} {
      flex-direction: column;
      align-items: stretch;

      .${classes.toolbar} {
        order: -1;
      }

      .${classes.header} {
        margin-right: 0;
      }
    }
  }
`;

export default getHeadingGroupCss;
